import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import "./index.css";

export default function ConfirInterviewModal({slotDetails, clientFirstName}) {
  const { bookedAppointmentData } = useSelector((state) => state.client);
  const { user } = useSelector((state) => state.user);
  const [userDetails, setUserDetails] = useState({ name: "" });

  useEffect(() => {
    localStorage.removeItem("offset");
    // let user = JSON.parse(localStorage.getItem("user"));
    setUserDetails(user);
  }, [user]);

  // useEffect(() => {
  //   setSlotDetails(slotData);
  // }, []);
  //hooks
  // const checTypeOfBooking = () => {
  //   let profType = localStorage.getItem('profType')
  //   let info = localStorage.getItem('bookingType');
  //   return info == "outreach" || profType == "after" ? true : false
  // }
   
  return (
    <div
      className="modal fade "
      id="interviewConfirmbooking"
      data-backdrop="static"
      role="dialog"
    >
      <div className="modal-dialog advanceConfirmbooking  modal-dialog-preview height-unset">
        <div className="modal-content">
          {/* <button
                type="button"
                class="close about-us-review-close  calendar-view-creoss-icin"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span className="cross-preview-box" aria-hidden="true">&times;</span>
              </button> */}
          <div className="modal-body">
            <div className="schedule-popup schedule-popup-interview">
              <img src="../images/new-cll.png" alt="user" />
             
             
                  <h5 className="schedule-popup-top">
                    Appointment Confirmed
                    {/* {userDetails && userDetails.first_name}, your appointment is
                    confirmed */}
                  </h5>
                  <span>Check your email now for meeting link, may be in spam/junk.</span>
                   <h5 className="schedule-popup-new">
                    {clientFirstName && clientFirstName !== "" ? `${clientFirstName}, ` : ""}your appointment is confirmed
                </h5>
                  {/* <div className="font-size-17">Check your email now for meeting link, may be in spam/junk.</div> */}
                
              {/* <span>

               
               
              </span>
              {", "} */}
              <p className="font-weight-bolder font-size-22">
                {slotDetails &&
                 moment(slotDetails.date, "YYYY-MM-DD").format("dddd, LL")}{" "}
              </p><br />
              <p className="font-weight-bolder font-size-22">
                {slotDetails &&
                  moment(
                    `${slotDetails.date} ${slotDetails.time}`,
                    "YYYY-MM-DD hh:mm A"
                  ).format("hh:mm A")}{" "}
              </p><br />
              <p className="font-weight-bolder font-size-22">
               
                with <b>{slotDetails && slotDetails.medium_name}</b>
              </p>  <br />
              {/* <div>

                <a className="advance-tag-my-calendar"
                  target="_blank"
                  href={slotDetails && slotDetails.calendarLink}
                >
                  Add to my calendar
                </a>
              </div> */}
                  <a
                    className=" advance-tag-margin advance-tag-my-calendar"

                    href={'/appointments'}
                  >
                    Continue 
                  </a>
                 
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
